(() => {
  const GLOBAL_KEY = '__jdFooterAccordion';
  const SELECTOR = '[data-footer-accordion]';
  const DESKTOP_QUERY = '(min-width: 990px)';

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].init(document);
    return;
  }

  const mediaQuery = window.matchMedia(DESKTOP_QUERY);
  const mobileState = new WeakMap();
  const managed = new Set();

  const sync = (details) => {
    if (!details?.isConnected) {
      managed.delete(details);
      return;
    }

    const summary = details.querySelector(':scope > summary');

    if (mediaQuery.matches) {
      if (!mobileState.has(details)) mobileState.set(details, details.open);
      details.open = true;
      details.dataset.desktopOpen = 'true';
      summary?.setAttribute('tabindex', '-1');
      summary?.setAttribute('aria-disabled', 'true');
      return;
    }

    if (details.dataset.desktopOpen === 'true') {
      details.open = mobileState.get(details) ?? false;
      delete details.dataset.desktopOpen;
    }
    summary?.removeAttribute('tabindex');
    summary?.removeAttribute('aria-disabled');
  };

  const init = (root = document) => {
    const elements = [];
    if (root.matches?.(SELECTOR)) elements.push(root);
    root.querySelectorAll?.(SELECTOR).forEach((details) => elements.push(details));

    elements.forEach((details) => {
      managed.add(details);
      sync(details);
    });
  };

  const syncAll = () => managed.forEach(sync);
  const destroy = (root) => {
    const elements = [];
    if (root.matches?.(SELECTOR)) elements.push(root);
    root.querySelectorAll?.(SELECTOR).forEach((details) => elements.push(details));
    elements.forEach((details) => managed.delete(details));
  };

  const module = { init, destroy };
  window[GLOBAL_KEY] = module;

  mediaQuery.addEventListener?.('change', syncAll);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

  init(document);
})();
